module.exports = __webpack_public_path__ + "static/media/Machine Heart.2b750dbc.jpg";